module.exports = __webpack_public_path__ + "img/bne-logo.c2ff9d6d.png";